import {Collaborator, Owner, OwnerInfo} from 'auth/PermissionConstants';
import {SearchSection} from 'graphql-client/__generated/graphqlGlobalTypes';
import {NonPaginatedSearchParams} from 'search/saved-searches/SavedSearchUtil';
import * as net from 'util/Net';
import pick from 'util/pick';

import {SavedSearchGraphQL} from '../../../graphql-fragments/search/__generated/SavedSearchGraphQL';

export function createSavedSearch(
  name: string,
  description: string,
  section: SearchSection,
  searchParams: NonPaginatedSearchParams,
  collaboratorsJson: {collaborators: Array<Collaborator>},
  ownerJson?: Owner,
  ownerInfoJson?: OwnerInfo
): Promise<SavedSearchGraphQL> {
  const collaborators = collaboratorsJson.collaborators.map((c) =>
    // @ts-expect-error
    pick(c, 'id', 'dataPolicyId', 'memberDataPolicyId', 'adminDataPolicyId')
  );
  return net.postJSONPromise({
    url: '/1/api/saved-searches',
    data: {
      name,
      description,
      section,
      searchParams,
      ownerAndCollaboratorsJson:
        ownerJson != null && ownerInfoJson != null
          ? {
              collaborators,
              owner: ownerJson.handle,
              ownerInfo: pick(ownerInfoJson, 'memberDataPolicyId'),
            }
          : {
              collaborators,
            },
    },
  });
}

export function deleteSavedSearch(savedSearchId: string): Promise<{}> {
  return net.deletePromise({url: `/1/api/saved-searches/${savedSearchId}`});
}

export interface UpdateSavedSearchParams {
  name?: string;
  description?: string;
  searchParams?: NonPaginatedSearchParams;
  ownerJson?: Owner;
  ownerInfoJson?: OwnerInfo;
  collaboratorsJson?: {collaborators: Array<Collaborator>};
}

export function updateSavedSearch(
  savedSearchId: string,
  savedSearchParams: UpdateSavedSearchParams
): Promise<{savedSearch: SavedSearchGraphQL}> {
  const params = {
    ...savedSearchParams,
    ownerAndCollaboratorsJson:
      savedSearchParams.collaboratorsJson != null &&
      savedSearchParams.ownerJson != null &&
      savedSearchParams.ownerInfoJson != null
        ? {
            collaborators: savedSearchParams.collaboratorsJson?.collaborators.map((c) =>
              // @ts-expect-error
              pick(c, 'id', 'dataPolicyId', 'memberDataPolicyId', 'adminDataPolicyId')
            ),
            owner: savedSearchParams.ownerJson.handle,
            ownerInfo: pick(savedSearchParams.ownerInfoJson, 'memberDataPolicyId'),
          }
        : undefined,
  };
  return net.patchJSONPromise({url: `/1/api/saved-searches/${savedSearchId}`, data: params});
}

export function markAsOpenedSavedSearch(savedSearchId: string): Promise<{}> {
  return net.postJSONPromise({url: `/1/api/saved-searches/${savedSearchId}/opened`});
}
